// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 22/04/2024

import { Component, OnDestroy, OnInit } from '@angular/core'
import { BaseController } from './base.controller';
import { Action, AuthService, CtButtonComponent, CtButtonUncompressedContainerComponent, CtColumnComponent, CtDialogComponent, CtInputTextComponent, CtRadioComponent, CtRowComponent, MenuService } from 'components';
import { UserOrganizations } from 'components/lib/models/UserOrganizations';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

const radioButtonComponentMetadata : any = {
	ctType: "CtRadio",
	controlProperties: {
	  hidden: false,
	  listenedComponentId: "",
	  listenedProperty: "",
	  border: true,
	  isChecked: 0,
	  readOnly: false,
	  labelValue: '',
	  value: '',
	  descriptionValue: '',
	  familyValue: "USER_ORGANIZATIONS",
	  id: '',
	  color : 'white',
	  modelId: "",
	  canBeClosed: true,
	},
	controlActions: [],
	models: []
}

const radioActionMetadata : any = {
	displayName: null,
	eventName: "onSelect",
	actionKey: null,
	type: "VIEW",
	action: "setCurrentOrganizationInput",
	isAsync: false,
	actionParams: [
	  '',
	  "num_cliente_pat_institution_01"
	],
	conditionParams: [],
	utilParams: [],
	preAction: null,
	postAction: null,
	params: [],
	actionsFlow: null,
	OperationType: null,
	Entity: null,
	Operation: "setCurrentOrganizationInput",
	Endpoint: null
}

const columnMetadata: any = {
	ctType: "CtColumn",
	controlProperties: {
	  hidden: false,
	  title: "",
	  size: 4,
	  id: ''
	},
	controlActions: [],
	models: []
};

@Component({
	selector: 'sg-vi06',
	template: `<div [id]="getId()" #target><div>`
})

export class SgVi06 extends BaseController {

	constructor(private authService : AuthService,
		private menuService : MenuService,
		private router : Router
	) {
		super();
		this.setViewCode('SG_VI06');
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */
	setUserInfoToInputs(action : Action){
		const organizationInput : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[0]);
		const userCodeInput : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
		const userIdInput : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[2]);
		const titleName: CtButtonUncompressedContainerComponent = this.utilService.getComponentRef(action.actionParams[3]);
		organizationInput.setValue(this.loggedUser.user.organization);
		userCodeInput.setValue(this.loggedUser.user.user_code);
		userIdInput.setValue(this.loggedUser.user.user_id);
		this.setTitleOrganizationName(titleName);
	}

	setTitleOrganizationName(titleName : CtButtonUncompressedContainerComponent){
		let organizationNameInUse = this.loggedUser.user.organization_name;
		titleName.setTitle(organizationNameInUse);
		}

	setOrganizations(action : Action) {
		const row : CtRowComponent = this.utilService.getComponentRef(action.actionParams[0]);
		const radioMetadataArr : any[] = [];
		this.authService.userOrganizations.forEach((organization : UserOrganizations, index : number) => {
			this.setOrganizationDataToMetadata(organization, index, radioMetadataArr, action);
		});
		this.renderRadioOrganizations(row, radioMetadataArr);
	}

	private renderRadioOrganizations(row : CtRowComponent, radioMetadataArr: any[]) {
		let rowMetadata : any = row.getMetaData();
		const columns : CtColumnComponent[] = this.genRadioColumns(radioMetadataArr);
		rowMetadata.models = columns;
		row.setMetaData(rowMetadata);
		row.ngAfterViewInit();
	}

	private genRadioColumns(radioMetadataArr: any[]): CtColumnComponent[] {
		const columns : CtColumnComponent[] = [];
		radioMetadataArr.forEach((radioMetadata, index) => {
			const colMetadata = JSON.parse(JSON.stringify(columnMetadata));
			colMetadata.controlProperties.id = `${this.viewCode}_column_organization_${index}`;
			colMetadata.models = [radioMetadata]
			if(index === 0) colMetadata.controlProperties.styleClass = 'ps-0 mt-2';
			else colMetadata.controlProperties.styleClass = 'mt-2';
 			columns.push(colMetadata);
		});
		return columns;
	}

	private setOrganizationDataToMetadata(organization: UserOrganizations, index: number, radioMetadataArr: any[], action : Action) {
		const metadata = JSON.parse(JSON.stringify(radioButtonComponentMetadata));
		metadata.controlProperties.labelValue = organization.docIdPat;
		metadata.controlProperties.value = organization.numCliente;
		metadata.controlProperties.descriptionValue = organization.nomCompleto;
		metadata.controlProperties.id = `${this.viewCode}_radio_organization_${index}`;
		metadata.controlProperties.isChecked = this.loggedUser.user.organization == organization.numCliente ? 1 : 0;
		metadata.controlActions = [
			this.setRadioOnSelectAction(action, `${this.viewCode}_radio_organization_${index}`)
		]
		radioMetadataArr.push(metadata);
	}

	private setRadioOnSelectAction(action : Action, radioId : string): any {
		const Raction = JSON.parse(JSON.stringify(radioActionMetadata));
		Raction.actionParams[0] = radioId;
		Raction.actionParams[1] = action.actionParams[1];
		Raction.actionParams[2] = action.actionParams[0];
		return Raction;
	}

	setCurrentOrganizationInput(action : Action) {
		const radioComponent : CtRadioComponent = this.utilService.getComponentRef(action.actionParams[0]);
		const organizationInput : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
		organizationInput.setValue(radioComponent.getValue());
		const row : CtRowComponent = this.utilService.getComponentRef(action.actionParams[2]);
		row.event2('onOrganizationSwitch');
	}

	managePostOrganizationSwitch(action : Action) {
		const dialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[0]);
		const organizationInput : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
		const titleName: CtButtonUncompressedContainerComponent = this.utilService.getComponentRef(action.actionParams[3]);
		dialog.setDescription(`Ahora puede gestionar la información de 
		${this.authService.userOrganizations.find(organization => organization.numCliente === organizationInput.getValue()).nomCompleto}`);
		
		const titleCasedName = this.authService.userOrganizations.find(
			organization => organization.numCliente === organizationInput.getValue()
		)?.nomCompleto.split(' ')
		  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		  .join(' ');
		
		this.authService.getToken().user.organization_name = titleCasedName;
		dialog.openDialog();
		this.refreshUser(action);
		this.markRadioAsChecked(action);
		this.setTitleOrganizationName(titleName);
		this.storeService.setState('organizationDialogOpen', true);
	}

	private markRadioAsChecked(action: Action) {
		const row : CtRowComponent = this.utilService.getComponentRef(action.actionParams[2]);
		row.getChildsByType(CtRadioComponent,true).forEach((radio : CtRadioComponent) => {
			radio.setIsChecked(radio.getValue() === this.loggedUser.user.organization);
		}); 
	}

	private refreshUser(action: Action) {
		const input : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
		this.authService.refreshUserAfterOrganizationChange(input.getValue());
	}
	/* -------------------- END CONTROLLER LOGIC ----------------- */

}